export default __webpack_public_path__ + "static/media/Leftarrow.5337be07.svg";